import {
    FETCH_SELF_VS_OTHERS_START,
    FETCH_SELF_VS_OTHERS_SUCCESS,
    FETCH_SELF_VS_OTHERS_FAIL,

} from "../../../constants";
import {
    FETCH_SELF_VS_OTHERS_URL,
} from "../../../../../config/constants";
import { createVisualizationFetchAction } from "./createVisualizationFetchAction";

export const getSelfVsOthers = createVisualizationFetchAction(FETCH_SELF_VS_OTHERS_URL, {
    START: FETCH_SELF_VS_OTHERS_START,
    SUCCESS: FETCH_SELF_VS_OTHERS_SUCCESS,
    FAIL: FETCH_SELF_VS_OTHERS_FAIL,
});
